export const teamColors: Record<string, string> = {
  // AL East
  BAL: '#DF4601', // Orioles Orange
  BOS: '#BD3039', // Red Sox Red
  NYY: '#003087', // Yankees Blue
  TB: '#092C5C', // Rays Navy
  TOR: '#134A8E', // Blue Jays Blue

  // AL Central
  CWS: '#27251F', // White Sox Black
  CLE: '#00385D', // Guardians Navy
  DET: '#0C2340', // Tigers Navy
  KC: '#004687', // Royals Blue
  MIN: '#002B5C', // Twins Navy

  // AL West
  HOU: '#002D62', // Astros Navy
  LAA: '#003263', // Angels Blue
  OAK: '#003831', // Athletics (Sacramento Athletics 2025-27, then Las Vegas A's 2028+)
  SEA: '#0C2C56', // Mariners Navy
  TEX: '#003278', // Rangers Blue

  // NL East
  ATL: '#CE1141', // Braves Scarlet
  MIA: '#00A3E0', // Marlins Blue
  NYM: '#002D72', // Mets Blue
  PHI: '#E81828', // Phillies Red
  WSH: '#AB0003', // Nationals Red

  // NL Central
  CHC: '#0E3386', // Cubs Blue
  CIN: '#C6011F', // Reds Red
  MIL: '#12284B', // Brewers Navy
  PIT: '#FDB827', // Pirates Yellow
  STL: '#C41E3A', // Cardinals Red

  // NL West
  ARI: '#A71930', // Diamondbacks Red
  COL: '#333366', // Rockies Purple
  LAD: '#005A9C', // Dodgers Blue
  SD: '#2F241D', // Padres Brown
  SF: '#FD5A1E', // Giants Orange
};
